(function () {
  // scroll reveal
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (e) { e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // mobile menu
  var toggle = document.querySelector('.menu-toggle');
  var links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // quantity steppers
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = parseInt(input.value, 10) || 1;
        v += b.dataset.dir === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
        if (input.form && input.closest('.cart-table')) input.form.submit();
      });
    });
  });

  // PDP variant select -> price update
  var sel = document.querySelector('[data-variant-select]');
  if (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var priceEl = document.querySelector('[data-price]');
      var btn = document.querySelector('[data-add-btn]');
      if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
      if (btn) {
        var avail = opt.dataset.available === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? btn.dataset.labelAdd : btn.dataset.labelSold;
      }
    });
  }
})();
